import React, { useState } from 'react';
import { RegisterSteps } from '../config/register-constants';
import { RegisterStep } from './register-step/register-step';
import { ROUTE_LOGIN } from '@shared/config/routes/routes';
import { useRedirect } from '@shared/lib/hooks/use-redirect/use-redirect';
import { WaitApproveStep } from './wait-approve-step/wait-approve-step';

export const FormRegisterUser: React.FC = () => {
    const redirect = useRedirect();
    const [userEmail, setUserEmail] = useState('');
    const [step, setStep] = useState(RegisterSteps.Register);

    return (
        <>
            <RegisterStep
                isShow={step === RegisterSteps.Register}
                onNextStep={(email: string) => {
                    setUserEmail(email);
                    setStep(RegisterSteps.WaitApprove);
                }}
                onPrevStep={() => {
                    redirect({ url: ROUTE_LOGIN, type: 'replace' });
                }}
            />
            <WaitApproveStep email={userEmail} isShow={step === RegisterSteps.WaitApprove} />
        </>
    );
};
